
import { StyleSheet, Dimensions } from 'react-native';
import { EDColors } from '../../constants/Colors';
import { Units } from '../../constants/Unit';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: EDColors.white,
    },
    lessonCon:{
        paddingTop: 5,
        backgroundColor: EDColors.topbar,
    },
    progressCon: {
        backgroundColor: EDColors.topbar,
        justifyContent: "center",
        paddingVertical: 10,
        paddingHorizontal: "20%",
        marginTop: -1,
    },
    lessonTxt: {
        fontFamily: Units.ftFamily.MontserratR,
        fontSize: Units.ftSizes.big,
        color: EDColors.gradient[2],
        alignSelf:'center',
    },
    body:{
        flex: 1,
        width: '100%',
        paddingHorizontal: "20%",
        paddingVertical: 10,
    },
    question: {
        fontFamily: Units.ftFamily.KarlaB,
        fontSize: Units.ftSizes.answer,
        lineHeight: 23,
        marginBottom: 10,
        paddingVertical: 10,
        color: EDColors.gradient[0],
    },
    quesTxt: {
        fontFamily: Units.ftFamily.KarlaB,
        fontSize: Units.ftSizes.answer,
        lineHeight: 23,
        paddingVertical: 10,
    },
    quesTxt2: {
        fontFamily: Units.ftFamily.KarlaR,
        fontSize: Units.ftSizes.answer,
        lineHeight: Units.isTablet? 25: 20,
    },
    optionCon:{
        paddingVertical: 20,
        paddingHorizontal: 10,
    },
    circle:{
        width: 16,
        height: 16,
        borderRadius: 8,
        borderWidth: 2,
        borderColor: EDColors.gradient[0],
        justifyContent: "center",
        alignItems: "center",
    },
    innerCircle: {
        width: 8,
        height: 8,
        borderRadius: 4,
        backgroundColor: EDColors.gradient[2],
    },
    answerCon: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        marginVertical: 5,
        paddingHorizontal: 10,
        borderWidth: 1,
        borderRadius: 5,
        minHeight: 60,
        borderColor: EDColors.itembdr
    },
    indexTxt: {
        fontFamily: Units.ftFamily.MontserratB,
        padding: Units.isTablet? 10: 5,
    },
    ansTxtCon: {
        padding: 10,
        width: '85%',
    },
    imgQues: {
        alignSelf: 'center',
        width: '90%',
        height: 250,
    },
    letterCon: {
        width: 25,
        alignItems: "center",
        paddingVertical: Units.isTablet? 10: 0,
    },
    otherModalCon:{
        flex: 1,
        width: "100%",
        height: "100%",
        position: "absolute",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: EDColors.modalbk,
        zIndex: 99,
    }
});

export default styles;